export { default as Mutation } from './Mutation';
export * from './Mutation';

export { default as Query } from './Query';
export * from './Query';

export { default as SubscribedQuery } from './SubscribedQuery';
export * from './SubscribedQuery';
